import { Component, OnInit } from '@angular/core';
import { VestibularService } from '../shared/vestibular.service';
import CursosMock from '../../../mocks/cursos/graduacao/cursos-graduacao.json';
import { environment } from '../../../environments/environment';
import { Cidade, Estado } from 'models/cidade-estado';

import { AgendamentoService } from 'app/vestibular/inscricao/agendamento/agendamento.service';
import { PessoaService } from 'app/shared/pessoa/pessoa.service';
import { InscricaoService } from 'app/vestibular/inscricao/shared/inscricao.service';
import { InscricaoResponse } from 'app/pos-graduacao/inscricao/shared/DadosInscricao';

@Component({
  selector: 'cm-inscricao-vestibular',
  templateUrl: './inscricao-vestibular.component.html',
  styleUrls: ['./inscricao-vestibular.component.scss'],
  providers: [AgendamentoService],
})
export class InscricaoVestibularComponent implements OnInit{
  /**
   * ---------------------------------
   */
  typewriter_text: string = "";
  typewriter_display: string = "";
  cursosText = false;
  passo = 1;
  curso;
  cursosMock;
  vestibularesAbertos = null;
  opcoesCurso=[];
  campus=new Array;
  campiSelecionado:any=null;
  turnos=new Array;
  turnoSelecionado;
  vestibulares=new Array;
  vestibularSelecionado;
  pedido:any;
  nomeCompleto;
  cpf;
  email='';
  celular='';
  vestibularEnem;
  notaEnem;
  anoEnem;
  locais;
  local;
  datas;
  data;
  canhoto;
  tipoPne;
  pne;
  dataNascimento='';
  confirmacaoEmail='';


  // constantes de validação
  public TIMEOUT_VALIDA_ID_MSECS = 1200;
  public CPF_MASK = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  public DT_MASK = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  // vars ctrl
  idLoading: boolean;
  idVerificado: boolean;
  idValido: boolean;
  cadastroExistente: boolean;
  imgValid: boolean;
  validarIdTimeout = null;
  linkEdital = '';
  opcoesUf: Estado[] = [];
  opcoesCidades: Cidade[] = [];
  msgErroIdInvalido: string;
  // vars form
  cpd: string;
  nome: string;
  rg: string;
  orgexp: string;
  telefone: string;
  dtNascimento: string;
  uf: any;
  cidade: any;
  aceiteTermos: boolean;
  dataImg: any;
  idVestibular: any;
  dadosCpd: any;
  cursoReingresso: any;
  vinculo: any;

  //Flags para liberação de inputs
  liberarOpcaoDeCurso:boolean=false;
  liberarOpcaoVestibular:boolean=false;
  liberarDadosPessoais:boolean=false;
  liberarNomeCandidato:boolean=false;
  liberarBotaoVestibularMedicina:boolean=false;
  liberarBotoesAcompanhamento:boolean=false;

  constructor(
    private vestibularService: VestibularService, 
    private agendamentoService: AgendamentoService, 
    private pessoaService: PessoaService,
    private inscricaoService: InscricaoService) { }


  ngOnInit() {
    this.cursosMock = CursosMock[0][environment.loginContexto];
    //console.log(this.cursosMock);
    this.typingCallback(this);
  }
  
  typingCallback(that) {
    that.typewriter_text = that.getMessage(that.passo);
    let total_length = that.typewriter_text.length;
    let current_length = that.typewriter_display.length;
    if (current_length < total_length) {
      that.typewriter_display += that.typewriter_text[current_length];
    } else if (current_length==total_length){
      switch(that.passo){
        case 1: // Início do Fluxo
        case 10:// Quando não encontramos opção de medicina
        case 11:// Quando não encontramos opção do curso
          that.cursosText = true;
          break;
        case 2: // Precisamos pegar o curso que foi selecionado pelo candidato e verificar se existe algum vestibular para ele
          that.getVestibularesDisponiveis(that);
          break;
        case 3: // Quando encontramos alguma opção de curso
          that.liberarOpcaoDeCurso=true;
          break;
        case 4: // Seleção de vestibular
          //console.log('tosco né');
          that.liberarOpcaoVestibular=true;
          break;
        case 5:
          that.liberarNomeCandidato = true;
          break;
        case 6:
          that.liberarDadosPessoais = true;
          break;
        case 8:
          that.liberarBotoesAcompanhamento = true;
          break;
        case 9:
          that.liberarBotaoVestibularMedicina = true;
          break;
      }
      return true;
    }else{
      that.typewriter_display = "";
    }
    setTimeout(that.typingCallback, 20, that);
  }

  /**
   * Refatorando processo de inscrição
   */

  // Método para buscar a mensagem que será mostrada para o usuário
  // A variável passo é para indicar em qual parte do processo ele está. É um número inteiro.
  getMessage(){
    let message: string;
    switch(this.passo){
      case 1:
        message = "Olá. Eu me chamo Thiago! Estou aqui para te ajudar a escolher o melhor curso para o seu futuro! Você tem algum curso em mente?";
        break;
      case 2:
        message = `Então você quer estudar ${this.curso.split("|")[1]}? Deixe-me verificar se existe algum vestibular disponível para ele. :)`;    
        break;
      case 3:
        message = "Encontrei algumas opções para você. Qual o campus e turno que você gostaria de estudar?";
        break;
      case 4:
        //console.log('teste');
        /**
        * Precisamos fazer uma varredura para verificar quais vestibulares possuem esta opção
        */
        let count=0;
        let descricaoCampus;
        this.opcoesCurso.forEach(opcaoCurso=>{
          //console.log(opcaoCurso);
          // Se o curso, campus e turno forem iguais, push no vestibular
          if(opcaoCurso.campus.id===this.campiSelecionado&&
            opcaoCurso.curso.id===this.curso.split("|")[0]&&
            opcaoCurso.id.turno===this.turnoSelecionado){
              this.vestibulares.forEach(vestibular=>{
                //console.log(vestibular);
                if(vestibular.ano===opcaoCurso.id.vestibular.ano&&vestibular.codigo===opcaoCurso.id.vestibular.codigo) count=1;
              })
              if(count===0){
                this.vestibulares.push({"descricao":opcaoCurso.id.vestibular.titulo,"codigo":opcaoCurso.id.vestibular.codigo,"ano":opcaoCurso.id.vestibular.ano,"sigla":opcaoCurso.id.vestibular.sigla});
              }
              count=0;
            }
        })
        //Agora vamos adicionar no dialog flow os vestibulares disponíveis
        let descricaoVestibular='';
        this.vestibulares.forEach(vestibular=>{
          if(descricaoVestibular===''){
            descricaoVestibular=` no `;
          }else{
            descricaoVestibular+=` e no `;
          }
          switch(vestibular.sigla){
            case 'TB':
              descricaoVestibular+=`Vestibular Tradicional de Bolsas`;
              break;
            case 'AG':
              descricaoVestibular+=`Vestibular Agendado`;
              break;
            case 'EA':
              descricaoVestibular+=`Vestibular EAD`;
              break;
            case 'ME':
            case 'MN':
              descricaoVestibular+=`Vestibular de Medicina`;
              break;
            case 'TR':
              descricaoVestibular+=`Vestibular Tradicional`;
              break;
            case 'BO':
              descricaoVestibular+=`Vestibular de Bolsas`;
              break;
            case 'RE':
              descricaoVestibular+=`Vestibular de Reingresso`;
              break;
            case 'EN':
              descricaoVestibular+=`Vestibular de ENEM`;
              break;
            default:
              descricaoVestibular+=`${vestibular.descricao}`;
              break;
          }
        })
        //console.log(descricaoVestibular);
        this.campus.forEach(campi=>{
          if(campi.id===this.campiSelecionado) descricaoCampus = campi.nome;
        })
        let descricao;
        switch(this.turnoSelecionado){
          case "I":
            descricao = "integral";
            break;
          case "M":
            descricao = "de manhã";
            break;
          case "N":
            descricao = "de noite";
            break;
          case "V":
            descricao = "de tarde";
            break;
        }
        message = `Massa! Você quer estudar ${this.curso.split("|")[1]}, ${descricao}, ${descricaoCampus[0]+descricaoCampus.substring(1).toLowerCase()}? Temos esta opção ${descricaoVestibular}.`;
        break;
      case 5:
        message = `Certo. Qual o seu nome completo?`;
        break;
      case 6:
        message = `Beleza, ${this.nomeCompleto.split(" ")[0]}! Agora vou precisar de alguns dados seus, para que eu possa fazer a sua iscrição no vestibular.`;
        break;
      case 7:
        message = `Qual o melhor local e data para você fazer a prova do vestibular?`;;
        break;
      case 8:
        message = `Parabéns! Você acabou de se inscrever no nosso vestibular! Mandamos um e-mail para você com alguns dados da sua inscrição. Dê uma conferida -lá ;)`;
        break;
      case 9:
        message = "O Vestibular de Medicina está aberto, mas não podemos concluir sua inscrição por aqui. No botão abaixo você pode continuar sua inscrição no Vestibular de Medicina.";
        break;
      case 10:
        message = "Não encontramos opção de Medicina porque este Vestibular ainda não está aberto para inscrições. Fique atento pois o Vestibular de Medicina ocorre todo ano. Gostaria de selecionar outro curso de seu interesse?";
        break;
      case 11:
        message = "Infelizmente não encontramos nenhuma opção disponível para você. Gostaria de ver alguma outra opção?";
        break;
    }

    return message;
  }

  getVestibularesDisponiveis(that){
    setTimeout(() => {
      that.vestibularService.getVestibularesDisponiveisPeloCurso(this.curso.split("|")[0]).subscribe(opcoes => {
        this.opcoesCurso = opcoes;
        if(this.opcoesCurso.length!=0){
          let campus = new Array;
          let count = 0;
          this.typewriter_display="";
          //Se for medicina, e existir opção, significa que precisamos mostrar uma mensagem diferenciada
          if(this.curso.split("|")[1]==='Medicina'){
            this.passo=9;
            this.typewriter_text= this.getMessage();
          }else{
            this.passo=3;
            this.typewriter_text=this.getMessage();
            this.opcoesCurso.forEach(element => {
              campus.forEach(campus=>{
                if(campus.nome==element.campus.nome) count=1;
              });
              if(count==0) campus.push({"nome":element.campus.nome,"id":element.campus.id});
              count=0;
            });
            //console.log(campus);
            this.campus = campus;
          }
          this.typingCallback(this);
        }else{
          this.typewriter_display="";
          if(this.curso.split("|")[1]==='Medicina'){
            this.passo=10;
            this.typewriter_text=this.getMessage();
          }else{
            this.vestibularesAbertos = null;
            this.passo=11;
            this.typewriter_text=this.getMessage();
          }
          this.typingCallback(this);
        }
     }, err => {
        console.log("Erro ao listar os cursos", err);
     })
    }, 2000);
  }

  verifyCourse(){
    this.cursosText = false;
    this.typewriter_display = "";
    this.passo = 2;
    this.typingCallback(this)
  }

  verifyCampus(){
    /**
     * Precisamos pegar o valor do Campus  selecionado e filtrar o json de opções de curso para
     * buscar os turnos disponíveis para aquele curso
     * I - Integral
     * M - Matutino
     * N - Noturno
     * V - Vespertino
     */
    this.turnos=[];
    this.opcoesCurso.forEach(element =>{
      if(element.campus.id===this.campiSelecionado && element.curso.id===this.curso.split("|")[0]){
        let descricao = null;
        let count = 0;
        switch(element.id.turno){
          case "I":
            descricao = "Integral";
            break;
          case "M":
            descricao = "De manhã";
            break;
          case "N":
            descricao = "De noite";
            break;
          case "V":
            descricao = "De tarde";
            break;
        }
        this.turnos.forEach(turno=>{
          if(turno.sigla===element.id.turno) count=1;
        })
        if(count===0) this.turnos.push({"descricao":descricao,"sigla":element.id.turno});
        count=0;
      }
    })
  }

  getDadosPessoais(){
    this.cursosText = false;
    this.typewriter_display = "";
    this.montarPedido(this.curso.split("|")[0],this.campiSelecionado,this.turnoSelecionado,null,null,null);
    this.passo=4;
    this.typewriter_text = this.getMessage();
    //console.log(this.pedido)
    this.typingCallback(this)
  }

  /**
   * Função que monta o pedido de inscrição, para ser enviado para o serviço de inscrição
   */
  montarPedido(curso,campus,turno,agendamento,candidato,vestibular){
    if(this.pedido!=undefined){
      if(this.pedido.curso!=null) curso=this.pedido.curso;
      if(this.pedido.campus!=null) curso=this.pedido.campus;
      if(this.pedido.turno!=null) curso=this.pedido.turno;
      if(this.pedido.agendamento!=null) curso=this.pedido.agendamento;
      if(this.pedido.candidato!=null) curso=this.pedido.candidato;
      if(this.pedido.vestibular!=null) curso=this.pedido.vestibular;
    }
    this.pedido = {
      agendamento:agendamento,
      campus:{"id":campus},
      turno:turno,
      candidato:candidato,
      vestibular:vestibular,
      curso:{"id":curso}
    }
  }

  verifyVestibular(){
    this.passo=5;
    this.typewriter_display = "";
    this.typingCallback(this)
  }

  verifyNomeCompleto(){
    this.passo=6;
    this.typewriter_display = "";    
    this.typingCallback(this);
  }

  verifyDadosPessoais(){
    /**
     * Aqui existe um problema de decisão, pois o vestibular pode ser de vários tipos:
     *  Tradicional
     *  Agendado
     *  Medicina
     *  Tradicional ENEM
     *  Agendado ENEM
     *  Tradicional Bolsas
     *  Agendado Bolsas
     * 
     * Todos esses caras possuem finais diferentes, alguns com agendamento, outros precisam digitar a nota do enem, outros não
     * Precisamos ter todos os passos de cada um
     */
    this.typewriter_display = "";
    switch(this.vestibularSelecionado.split("-")[2]){
      case 'AG': //Agendado
        this.passo=7;
        this.typewriter_text = this.getMessage();
        this.buscarCampusAgendamento();
        break;
      case 'EN': //Enem
        this.passo=8;
        this.typewriter_text = `Me informe qual foi a sua nota do ENEM, e em qual ano você fez esta pontuação.`;
        break;
      default:
        /**
         * Aqui precisamos inscrever o candidato
         */
        let response = this.finalizarInscricao();
        break;
    }
    //console.log(this.passo);
    this.typingCallback(this);
  }

  getDatasAgendamento(localParam){
    try{
      this.buscarDatasDisponiveis().then((result)=>{
        this.datas = result['datas'];
        //console.log(this.datas);
      });
    }catch (error) {
      throw new Error(error);
    }
  }

  finalizarInscricao(){
    //Precisamos finalizar a montagem pedido para enviarmos para o vestibular-api
    //Agendamento
    if(this.data!=undefined&&this.local!=undefined){
      this.pedido.agendamento={
        campus:{
          id:this.local.codigo
        },
        codigoHora: this.data.codigoHora,
        data: this.data.date
      }
    }
    let canhoto = "N";
    if(this.canhoto) canhoto = "S";
    let codigoNecessidadeEspecial = null;
    switch(this.pne){
      case 'motora':
        codigoNecessidadeEspecial = 3;
        break;
      case 'auditiva':
        codigoNecessidadeEspecial = 4;
        break;
      case 'visual':
        codigoNecessidadeEspecial = 2;
        break;
      default:
        codigoNecessidadeEspecial = 1;
        break;
    }
    let dataNascimento = this.dataNascimento.split("/");
    this.pedido.candidato = {
      cpf:this.cpf.replace(/[^\d]+/g, ''),
      dataNascimento: `${dataNascimento[2]}-${dataNascimento[1]}-${dataNascimento[0]}`,
      email: this.email,
      necessidadeEspecial: this.pne,
      nome: this.nomeCompleto,
      telefone: this.celular.replace(/[^\d]+/g, ''),
      usuarioCanhoto: canhoto,
      codigoNecessidadeEspecial: codigoNecessidadeEspecial
    }
    let vestibular = this.vestibularSelecionado.split("-");
    this.pedido.vestibular = {
      ano: vestibular[0],
      codigo: vestibular[1],
      siglaVestibular: vestibular[2]
    }
    //console.log(this.pedido);
    this.inscricaoService.inscrever(this.pedido,true).then( (response:InscricaoResponse) => {
      this.typewriter_display = "";
      this.typewriter_text = this.getMessage();
      this.passo=8;
      this.typingCallback(this);
    }).catch(error =>{
      console.log(error);
    })
  }

  async buscarCampusAgendamento() {
    try {
      const agendamentosDTO: any = await this.agendamentoService.buscarCampusAgendamento(this.vestibularSelecionado.split("-")[2]);
      if (!agendamentosDTO) {
        throw new Error('Não foi possível recuperar os campus para agendamento.');
      }
      this.locais = agendamentosDTO.campus;
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }

  buscarDatasDisponiveis() {
    const agendamentosDTO = this.agendamentoService.buscarDatasDisponiveis(this.vestibularSelecionado.split("-")[0], this.vestibularSelecionado.split("-")[1], this.local.codigo);
    return agendamentosDTO;
  }

  /**
   * -------------------- FUNÇÕES DE VALIDAÇÃO --------------------
   */
  initVars() {
    this.idLoading = false;
    this.idVerificado = false;
    this.idValido = false;
    this.cadastroExistente = false;
    this.nome = '';
    this.email = '';
    this.telefone = '';
    this.dtNascimento = '';
    this.uf = '';
    this.cidade = '';
    this.aceiteTermos = false;
    this.dataImg = { clean: true };
    this.dadosCpd = undefined;
    this.msgErroIdInvalido = undefined;
    this.rg = '';
    this.orgexp = '';
    this.vinculo = null;
  }

  validaCpf(now = false) {
    const milisecs = now ? 1 : this.TIMEOUT_VALIDA_ID_MSECS;

    if (this.validarIdTimeout !== null) {
      clearTimeout(this.validarIdTimeout);
    }

    // limpa variaveis de controle
    this.initVars();

    this.validarIdTimeout = setTimeout(() => {

      const thisTimeout = this.validarIdTimeout;
      if (!this.cpf || this.cpf.length === 0) {
        return;
      }

      this.idValido = this.pessoaService.validarCpf(this.cpf);

      if (!this.idValido) {
        this.idVerificado = true;
        return;
      }

      this.idLoading = true;
    }, milisecs);

  }

  isEmailValido() {
    const emailUser = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@/;
    const emailProvider = /(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    const regex = new RegExp([emailUser, emailProvider].map(r => r.source).join(''));

    if (regex.test(this.email)) {
      return true;
    }
    return false;
  }

  isTelefoneValido() {
    const tel = this.celular.replace(/[^\d]+/g, '');
    if (!tel || tel.length < 10) {
      return false;
    }
    return true;
  }

  telefoneMask(rawValue) {
    if (rawValue) {
      const tel = rawValue.replace(/[^\d]+/g, '');

      // novos telefones com o nono dígito
      if (tel && tel.length > 10) {
        return ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      }
    }

    return ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  }

  isDtNascimentoValida() {
    if (!this.dataNascimento || this.dataNascimento.length < 10) {
      return false;
    }

    try {
      const dateParts = this.dataNascimento.split('/');
      const dia = parseInt(dateParts[0], 10);
      const mes = parseInt(dateParts[1], 10);
      const ano = parseInt(dateParts[2], 10);
      const date = new Date(ano, mes - 1, dia);

      if (date.getFullYear() === ano
        && date.getMonth() + 1 === mes
        && date.getDate() === dia) {

        if (date > new Date()) {
          return false;
        }
        return true;
      }
    } catch (error) {
      // para pegar datas vazias ou nao completas, daria erro no split
      // quer dizer q nao é valida
    }
    return false;
  }

  emailConfirmado(){
    //console.log(this.confirmacaoEmail);
    //console.log(this.email);
    if(this.confirmacaoEmail===this.email) return true;
    return false;
  }

  enableSalvar(): boolean {
    if (!this.isDtNascimentoValida() || !this.isEmailValido() || !this.isTelefoneValido() || !this.emailConfirmado())
      return false;
    return true;
  }

}
